import {Button, Link} from "@material-ui/core";

export default function Footer(props) {

    const button = <Button style={{margin: "25px"}} type="button" onClick={props.showDataProtection}>
        Datenschutz
    </Button>
    const dataProtectionLink = <Link style={{margin: "25px"}} href="/#/dataprotection">Datenschutz</Link>
    const dataProtection = props.showDataProtection === undefined ? dataProtectionLink : button
    return (<footer>
            <Link style={{margin: "25px"}} href="https://www.leibniz-ipn.de/de/das-ipn/impressum">Impressum</Link>
            {dataProtection}
        </footer>)
}